export const environment = {
    production: true,
    env: 'production',
    apiUrl: 'https://api.prod.macdonnell.h6.run',
    s3BucketName: '',
    imgixDomain: 'https://images.macdonnell.h6.run',
    whitelistedDomains: ['api.prod.macdonnell.h6.run'],
    blacklistedRoutes: [],
    gaMeasurementId: 'G-SYB2S1CHRP',
    support: {
        enabled: true,
        orgId: 71,
        orgName: 'MacDonnell Regional Council',
        primaryColor: '#1e2454',
    },
};
